// 外部联系人页面
import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroller";
//import "./index.less";

import { IItemData } from "./common.typing";
import PageTitle from "./PageTitle";
import CommonList from "./CommonList";
import locale from "../../_util/locale";

export interface ExternalContactProps {
    prePage: string;
    onChangeCurPage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    getContactList?: (last_id: number, pageSize: number) => Promise<any>;
    /** 不可用 id，包括 group、user、session、org */
    disabledids?: string[];
    requiredList?: IItemData[];
    multiple?: boolean;
}

const ExternalContact: React.FC<ExternalContactProps> = ({
    prePage,
    onChangeCurPage,
    currentList,
    setCurrentList,
    getContactList,
    disabledids,
    requiredList,
    multiple,
}) => {
    const [contactList, setContactList] = useState([]);
    const [more, setMore] = useState(true);
    const [lastid, setLastid] = useState<number>(0);
    let pageSize = 20;

    useEffect(() => {
        console.log("useEffect");
        loadContactList();
    }, []);

    const loadContactList = async () => {
        if (getContactList && more) {
            const { list: result, last_id } = await getContactList(
                lastid,
                pageSize
            );

            // last_id 为 0 代表请求完所有数据了
            if (last_id === 0) {
                setMore(false);
            }
            setLastid(last_id);
            if (contactList) {
                setContactList(prev => {
                    return prev.concat(result);
                });
            } else {
                setContactList(result);
            }
        }
    };

    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };

    return (
        <div className="externalContact">
            {/* <PageTitle
                {...{
                    title: locale("useradd_type_contact"),
                    onBack,
                }}
            /> */}
            <div className="contactList">
                <InfiniteScroll
                    initialLoad={false}
                    loadMore={loadContactList}
                    hasMore={more}
                    useWindow={false}
                >
                    <CommonList
                        {...{
                            type: "contact",
                            showCheckAll: true,
                            list: contactList,
                            currentList,
                            setCurrentList,
                            disabledids,
                            requiredList,
                            multiple,
                        }}
                    />
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default ExternalContact;
